<script>
	import {
		defineComponent
	} from 'vue'
	import {
		goodsCates,
		goodsYearList,
		goodsList
	} from "../api/api";
	import router from "../router";

	export default defineComponent({
		name: "search",
		data() {
			return {
				goodsData: [],
				inputValue: '',
				//牌品分类arr
				classArr: [],
				classArr2: [],
				classIndex1: null,
				classIndex2: null,
				cate_ids: "",
				list: [],
				year: "",
				keyword: "",
				page: 1,
				total: null
			}
		},
		created() {
			console.log('wolaile');
			this.keyword = this.$route.query.values
			this.getClass1()
			this.getClass2()
			this.hdList()
		},
		watch: {
			'$route'(to, from) {
				//刷新参数放到这里里面去触发就可以刷新相同界面了
				this.keyword = this.$route.query.values
				this.getClass1()
				this.getClass2()
				this.hdList()
			}
		},
		methods: {
			pageChange(e) {
				console.log(e)
				this.page = e
				this.hdList()
			},
			go(e) {
				router.push({
					name: 'productDetail',
					query: {
						id: e.id
					}
				})
			},
			chongzhi() {
				this.cate_ids = ''
				this.year = ''
				this.keyword = ''
				this.classIndex1 = null
				this.classIndex2 = null
				this.page = 1
				this.hdList()

			},
			dianji1(e, index) {
				console.log(e, index, '打印jjjjj')
				this.classIndex1 = index
				this.cate_ids = e.id
				console.log(this.cate_ids, "idya")
				this.page = 1
				this.hdList()
			},
			dianji2(e, index) {
				console.log(e, index, '打印jjjjj')
				this.classIndex2 = index
				this.year = e
				this.page = 1
				this.hdList()

			},
			getClass1() {
				goodsCates({}).then(res => {
					console.log(res, '打印res')
					this.classArr = res.data.data
				})
			},
			getClass2() {
				goodsYearList({}).then(res => {
					console.log(res, '打印res')
					this.classArr2 = res.data.data.list
				})
			},
			handleChange() {
				this.page = 1
				this.hdList()
			},
			hdList() {
				goodsList({
					cate_ids: this.cate_ids,
					year: this.year,
					keyword: this.keyword,
					page: this.page
				}).then(res => {
					this.list = res.data.data.list.data
					this.total = res.data.data.list.total
					console.log(this.list, '列表打印+-')
					// this.classArr2 = res.data.data.list
				})
			}
		}
	})
</script>

<template>
	<div>

		<section class="bg-light padding-large">
			<div class="container">
				<div class="row" style="margin-bottom: 50px">
					<el-input placeholder="请输入内容" @change="handleChange" prefix-icon="el-icon-search" v-model="keyword">
					</el-input>
				</div>
			</div>
			<div class="container">
				<div class="row" style="margin-bottom: 30px">
					<el-button @click="chongzhi">重置</el-button>
				</div>
			</div>
			<div class="container">
				<div class="row" style="margin-bottom: 50px">
					<div class="fenLeiBox">
						<div class="left">拍品分类：</div>
						<div class="right">
							<div :class="classIndex1 == index ? 'mod2' : 'mod' " @click="dianji1(item,index)"
								v-for="(item,index) in classArr">{{item.title}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container">
				<div class="row" style="margin-bottom: 50px">
					<div class="fenLeiBox">
						<div class="left">拍品会：</div>
						<div class="right">
							<div :class="classIndex2 == index ? 'mod2' : 'mod' " @click="dianji2(item,index)"
								v-for="(item,index) in classArr2">{{item}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container">
				<div class="row">
					<div class="post-item col-md-3" v-for="(item,index) in list" :key="index" @click="go(item)">
						<figure class="zoom-effect">
							<div class="zoom-in"><img :src="item.image" style="height: 200px;object-fit: cover;"
									alt="stories" class="lgpostImg img-fluid"></div>
						</figure>
						<div class="story-title-wrap mt-3">
							<h4 class="story-title">{{item.title}}</h4>
							<div class="post-meta">{{item.describe}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container">
				<div class="row">
					<el-pagination background :page-size='10' layout="prev, pager, next" @current-change="pageChange"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</section>
	</div>
</template>

<style scoped>
	@import 'css/main.css';

	.fenLeiBox {
		display: flex;

		.right {
			display: flex;
			flex-wrap: wrap;

			.mod2 {
				border: 1px solid #51B56D;
				padding: 2px 10px;
				border-radius: 10px;
				margin-right: 20px;
				font-size: 15px;
				color: #51B56D;
				cursor: pointer;
			}

			.mod {
				cursor: pointer;
				padding: 2px 10px;
				border-radius: 10px;
				margin-right: 20px;
				font-size: 15px;
				border: 1px solid #f8f9fa;
			}

			.mod:hover {
				cursor: pointer;
				border: 1px solid #51B56D;
				padding: 2px 10px;
				border-radius: 10px;
				margin-right: 20px;
				font-size: 15px;
				color: #51B56D;
			}

		}
	}
</style>


// WEBPACK FOOTER //
// src/view/search.vue